document.addEventListener('DOMContentLoaded', function () {
  /*
  ============================================================
  LANDING PAGE INTRO AND MOBILE MENU
  ============================================================
  */

  const landingPages = document.querySelectorAll('[data-cl-landing]');

  landingPages.forEach(function (page) {
    window.requestAnimationFrame(function () {
      page.classList.add('is-ready');
      const metalButtons = page.querySelectorAll('[data-cl-metal-option]');
const metalMedia = page.querySelectorAll(
  '[data-cl-metal-media]'
);

function switchHeroMetal(metal) {
  metalMedia.forEach(function (media) {
    const isSelected = media.dataset.clMetalMedia === metal;

    media.classList.toggle('is-active', isSelected);

    if (media.tagName === 'VIDEO') {
      if (isSelected) {
        const playPromise = media.play();

        if (playPromise !== undefined) {
          playPromise.catch(function () {
            // Autoplay may be restricted in preview mode.
          });
        }
      } else {
        media.pause();
      }
    }
  });

  metalButtons.forEach(function (button) {
    const isSelected = button.dataset.clMetalOption === metal;

    button.classList.toggle('is-active', isSelected);
    button.setAttribute('aria-pressed', String(isSelected));
  });

  page.dataset.selectedMetal = metal;
}

metalButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    switchHeroMetal(button.dataset.clMetalOption);
  });
});
    });

    const menuButton = page.querySelector('[data-cl-menu-button]');
    const mobileMenu = page.querySelector('[data-cl-mobile-menu]');

    if (!menuButton || !mobileMenu) return;

    function closeMenu() {
      mobileMenu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    }

    menuButton.addEventListener('click', function () {
      const isOpen =
        menuButton.getAttribute('aria-expanded') === 'true';

      menuButton.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );

      mobileMenu.hidden = isOpen;
    });

    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });
  });

  /*
  ============================================================
  GALLERY SCROLL ANIMATION
  ============================================================
  */

  const galleryCards = document.querySelectorAll(
    '[data-cl-gallery-card]'
  );

  if (galleryCards.length) {
    if (!('IntersectionObserver' in window)) {
      galleryCards.forEach(function (card) {
        card.classList.add('is-visible');
      });
    } else {
      const galleryObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      galleryCards.forEach(function (card) {
        galleryObserver.observe(card);
      });
    }
  }

  /*
  ============================================================
  RING CONFIGURATOR
  ============================================================
  */

const configurator = document.querySelector('#cl-configurator');

if (!configurator) {
  console.warn('Carat Legacy configurator not found.');
  return;
}

  const state = {
    metal: 'Yellow Gold',
    stone: 'Lab-Grown Diamond',
    purity: '18K',
    size: '21',
    engraving: ''
  };

  const summaryValues = {
    metal: configurator.querySelector('[data-summary-metal]'),
    stone: configurator.querySelector('[data-summary-stone]'),
    purity: configurator.querySelector('[data-summary-purity]'),
    size: configurator.querySelector('[data-summary-size]'),
    netWeight: configurator.querySelector(
      '[data-summary-net-weight]'
    ),
    stoneWeight: configurator.querySelector(
      '[data-summary-stone-weight]'
    ),
    grossWeight: configurator.querySelector(
      '[data-summary-gross-weight]'
    ),
    engraving: configurator.querySelector(
      '[data-summary-engraving]'
    )
  };

  const previewText = configurator.querySelector(
    '.cl-configurator__preview-footer p'
  );

  const priceElement = configurator.querySelector(
    '.cl-configurator__price strong'
  );

  const quoteButton = configurator.querySelector(
    '.cl-configurator__cta'
  );

  const priceDescription = configurator.querySelector(
    '[data-price-description]'
  );

  const ringSize = configurator.querySelector('#cl-ring-size');

  const engravingInput = configurator.querySelector(
    '#cl-engraving'
  );

  const engravingButton = configurator.querySelector(
    '.cl-engraving__button'
  );

  const previewImages = configurator.querySelectorAll(
    '[data-metal-preview]'
  );

  /*
============================================================
LEGACY X RING PRICING CONFIGURATION

Edit future rates only inside this section.
============================================================
*/

const pricingConfig = {
  gold24KRatePerGram: 15186,
  silverRatePerGram: 222,
  labourPerGram: 1500,

  baseNetMetalWeight9K: 5.5,

  stoneCarats: 1.44,
  gramsPerCarat: 0.2,

  purityPercentages: {
    '18K': 0.76,
    '9K': 0.39
  },

  metalWeightFactors: {
    '18K': 1.3889,
    '9K': 1,
    'Silver': 1
  },

  stoneRatePerCarat: {
    'Natural Diamond': 75000,
    'Lab-Grown Diamond': 20000,
    'Moissanite': 5000
  }
};

  function setText(element, value) {
    if (element) {
      element.textContent = value;
    }
  }
function formatCurrency(value) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(Math.round(value));
}
  function calculateWeight() {
  const weightFactor =
    pricingConfig.metalWeightFactors[state.purity] || 1;

  const netWeight =
    pricingConfig.baseNetMetalWeight9K * weightFactor;

  const stoneCarats = pricingConfig.stoneCarats;

  const stoneWeightGrams =
    stoneCarats * pricingConfig.gramsPerCarat;

  const grossWeight =
    netWeight + stoneWeightGrams;

  return {
    netWeight: netWeight,
    stoneCarats: stoneCarats,
    stoneWeightGrams: stoneWeightGrams,
    grossWeight: grossWeight
  };
}
function calculatePrice(weight) {
  let metalRatePerGram = 0;

  if (state.purity === 'Silver') {
    metalRatePerGram =
      pricingConfig.silverRatePerGram;
  } else {
    const purityPercentage =
      pricingConfig.purityPercentages[state.purity] || 0;

    metalRatePerGram =
      pricingConfig.gold24KRatePerGram *
      purityPercentage;
  }

  const stoneRatePerCarat =
    pricingConfig.stoneRatePerCarat[state.stone] || 0;

  const metalValue =
    weight.netWeight * metalRatePerGram;

  const stoneValue =
    weight.stoneCarats * stoneRatePerCarat;

  const labourValue =
    weight.netWeight * pricingConfig.labourPerGram;

  const estimatedTotal =
    metalValue +
    stoneValue +
    labourValue;

  return {
    metalRatePerGram: metalRatePerGram,
    metalValue: metalValue,
    stoneValue: stoneValue,
    labourValue: labourValue,
    estimatedTotal: estimatedTotal
  };
}
  function updateSelectedState(group, selectedButton) {
    const buttons = group.querySelectorAll('button');

    buttons.forEach(function (button) {
      const selected = button === selectedButton;

      button.classList.toggle('is-selected', selected);
      button.setAttribute(
        'aria-pressed',
        selected ? 'true' : 'false'
      );
    });
  }

  function updatePreviewImage() {
   previewImages.forEach(function (preview) {
    const previewMetal =
      preview.getAttribute('data-metal-preview');

    const isSelected =
      previewMetal === state.metal;

    preview.classList.toggle(
      'is-active',
      isSelected
    );
  });
}

function updateQuoteLink(weight, price) {
      if (!quoteButton) return;

    const message = [
  'Hello Carat Legacy,',
  '',
  'I would like an exact quotation for:',
  '',
  'Product: The Legacy X Ring',
  `Metal colour: ${state.metal}`,
  `Metal / Purity: ${state.purity}`,
  `Stone: ${state.stone}`,
  `Ring size: ${state.size}`,
  `Estimated net metal weight: ${weight.netWeight.toFixed(3)} g`,
  `Stone weight: ${weight.stoneCarats.toFixed(3)} ct`,
  `Estimated gross weight: ${weight.grossWeight.toFixed(3)} g`,
  `Metal value: ${formatCurrency(price.metalValue)}`,
  `Stone value: ${formatCurrency(price.stoneValue)}`,
  `Labour: ${formatCurrency(price.labourValue)}`,
  `Estimated price: ${formatCurrency(price.estimatedTotal)}`,
  `Engraving: ${state.engraving || 'Not selected'}`,
  '',
  'Please confirm the final CAD weight and exact quotation.'
].join('\n');

    const whatsappNumber = '918884440713';

    quoteButton.href =
      'https://wa.me/' +
      whatsappNumber +
      '?text=' +
      encodeURIComponent(message);

    quoteButton.target = '_blank';
    quoteButton.rel = 'noopener';
  }

  function updateSummary() {
  const weight = calculateWeight();
  const price = calculatePrice(weight);

    setText(summaryValues.metal, state.metal);
    setText(summaryValues.stone, state.stone);
    setText(summaryValues.purity, state.purity);
    setText(summaryValues.size, state.size);

    setText(
      summaryValues.netWeight,
      weight.netWeight.toFixed(3) + ' g'
    );

    setText(
      summaryValues.stoneWeight,
      weight.stoneCarats.toFixed(3) + ' ct'
    );

    setText(
      summaryValues.grossWeight,
      weight.grossWeight.toFixed(3) + ' g'
    );

    setText(
      summaryValues.engraving,
      state.engraving || 'Not selected'
    );

    if (previewText) {
      previewText.textContent =
        state.purity +
        ' · ' +
        state.metal +
        ' · ' +
        state.stone +
        ' · Size ' +
        state.size;
    }

    if (priceElement) {
  priceElement.textContent =
    formatCurrency(price.estimatedTotal);
}

    if (priceDescription) {
  priceDescription.textContent =
    'Metal: ' +
    formatCurrency(price.metalValue) +
    ' · Stone: ' +
    formatCurrency(price.stoneValue) +
    ' · Labour: ' +
    formatCurrency(price.labourValue) +
    '. GST excluded. Final quotation may vary after CAD and final production weight.';
}

    updatePreviewImage();
    updateQuoteLink(weight, price);
  }

  const optionGroups = configurator.querySelectorAll(
    '[data-option-group]'
  );

  optionGroups.forEach(function (group) {
    group.addEventListener('click', function (event) {
      const button = event.target.closest('button');

      if (!button || !group.contains(button)) return;

      const optionType =
        group.getAttribute('data-option-group');

      const selectedValue =
        button.getAttribute('data-value');

      if (!optionType || !selectedValue) return;

      updateSelectedState(group, button);

      state[optionType] = selectedValue;

      updateSummary();
    });
  });

  if (ringSize) {
    state.size = ringSize.value || '21';

    ringSize.addEventListener('change', function () {
      state.size = ringSize.value;
      updateSummary();
    });
  }

  function saveEngraving() {
    if (!engravingInput) return;

    state.engraving =
      engravingInput.value.trim().slice(0, 18);

    engravingInput.value = state.engraving;

    if (engravingButton) {
      engravingButton.textContent =
        state.engraving ? 'ADDED' : 'ADD';
    }

    updateSummary();
  }

  if (engravingButton) {
    engravingButton.addEventListener(
      'click',
      saveEngraving
    );
  }

  if (engravingInput) {
    engravingInput.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();
        saveEngraving();
      }
    );
  }

  updateSummary();
});